'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { CgClose, CgMenuRightAlt } from 'react-icons/cg';

// import Modal from 'react-modal';
import { DropDown } from './DropDown';
import { RelatedPostModel } from './RelatedPostModel';
export const Header = t0 => {
  const $ = _c(40);
  const {
    tags,
    recentPost
  } = t0;
  const [open, setOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setModalIsOpen(false);
      setOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleInitialState = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      handleInitialState();
      return () => window.removeEventListener("resize", handleResize);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== open) {
    t4 = value => {
      if (value !== undefined) {
        setOpen(value);
        return;
      }
      setOpen(!open);
    };
    $[3] = open;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleMenu = t4;
  let t5;
  if ($[5] !== modalIsOpen) {
    t5 = () => {
      setModalIsOpen(!modalIsOpen);
    };
    $[5] = modalIsOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const openModal = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/" className="text-xl font-semibold">AbleSpace</Link>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== open) {
    t7 = () => setOpen(!open);
    $[8] = open;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = open ? "Close menu" : "Open menu";
  let t9;
  if ($[10] !== open) {
    t9 = open ? <CgClose size={32} color="#4E4E4E" /> : <CgMenuRightAlt size={32} color="#4E4E4E" />;
    $[10] = open;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <div className="relative z-10 flex h-full w-full items-center justify-between bg-white px-6 py-5 lg:w-fit lg:p-0">{t6}<button onClick={t7} className="lg:hidden" aria-label={t8}>{t9}</button></div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `${open ? "-left-6 top-0" : "top-[-2000px] lg:top-0"} fixed mt-16 h-screen w-full items-center justify-between bg-white px-4 pt-3 duration-500 md:px-8 md:pt-6 lg:relative lg:mt-0 lg:flex lg:h-fit lg:px-0 lg:pt-0`;
  let t12;
  if ($[16] !== handleMenu) {
    t12 = <Link href="/blog/page/1"><span className="flex items-center pt-0.5 text-lg" onClick={() => handleMenu(false)}>Blogs</span></Link>;
    $[16] = handleMenu;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== handleMenu) {
    t13 = <span className="flex items-center"><DropDown handleMenu={handleMenu} /></span>;
    $[18] = handleMenu;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== open || $[21] !== openModal) {
    t14 = !open && <div className="cursor-pointer rounded-full border-2 px-1 py-0.5 hover:border-blue-600 hover:text-blue-600"><button onClick={openModal}>• • •</button></div>;
    $[20] = open;
    $[21] = openModal;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t14) {
    t15 = <div className="flex flex-col gap-6 md:ml-4 lg:flex-row lg:flex-wrap lg:justify-center">{t12}{t13}{t14}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== handleMenu || $[28] !== isMobile || $[29] !== open || $[30] !== recentPost || $[31] !== tags) {
    t16 = open && (isMobile ? "" : "", <div className="" onClick={() => handleMenu(false)}><RelatedPostModel tags={tags} recentPost={recentPost} isMobile={isMobile} /></div>);
    $[27] = handleMenu;
    $[28] = isMobile;
    $[29] = open;
    $[30] = recentPost;
    $[31] = tags;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t11 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className={t11}>{t15}{t16}</div>;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t10 || $[38] !== t17) {
    t18 = <div><nav className="source-sans-3 slide-down fixed  top-0 z-10  mt-0 w-full bg-white px-2 shadow-sm md:px-2 md:py-3 "><div className="flex items-center justify-between space-x-6 lg:px-20">{t10}{t17}</div></nav></div>;
    $[37] = t10;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};